export default "__VITE_ASSET__GLi2gGYO__"